/* eslint-disable quotes */
import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import { FormattedMessage } from "react-intl";

import { Pluggable } from "@folio/stripes/core";

const InventoryTemplatesSettings = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="list-templates"
    >
      <FormattedMessage id="ui-inventory.templatesPluginNotAvailable" />
    </Pluggable>
  );
};

InventoryTemplatesSettings.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default InventoryTemplatesSettings;
